import React from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components';
import {withTheme} from './../../themes'

const Wrapper  = styled.div`
  position: relative;
  display: inline-block;
  width: ${props => props.size.value+props.size.unit};
  height: ${props => props.height ? `${props.height.value}${props.height.unit}` : `${props.size.value}${props.size.unit}`};
  line-height: ${props => props.size.value+props.size.unit};
  border-radius: 100%;
  background-color: ${props => props.background};
  opacity: ${props => props.opacity};

  &:hover{
    background-color: ${props => props.hoverBackground};
  }
`;
const Image  = styled.div`
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: ${props => props.color};
  mask: url("/assets/icons/${props => props.name}.svg") no-repeat 50% 50%;
  mask-size: ${props => props.scale*100}% ${props => props.scale*100}%;

  &:hover{
    background-color: ${props => props.hoverColor};
  }
`;


const Icon = ({
  name,
  color = "#000000",
  background,
  hoverColor = color,
  hoverBackground = background,
  opacity = 1,
  size = {value: 60, unit: "px"},
  height = null,
  theme,
  styles
}) => {

  return (
    <Wrapper style={styles} size={size} height={height} background={background} hoverBackground={hoverBackground} opacity={opacity}>
      <Image
        name={name}
        color={color}
        hoverColor={hoverColor}
        scale={background ? theme.icons.scale.wrapped : theme.icons.scale.normal}
      />
    </Wrapper>
  )
}

Icon.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  background: PropTypes.string,
  hoverColor: PropTypes.string,
  hoverBackground: PropTypes.string,
  opacity: PropTypes.number,
  size: PropTypes.object
}

export default withTheme(Icon)
